import { ArrowDown, ClipboardCheck, Eye, MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const steps = [
  { key: "recognise", Icon: Eye },
  { key: "consider", Icon: MessageCircle },
  { key: "discuss", Icon: ClipboardCheck },
] as const;

export function LearningVisualLesson({
  title,
  focus,
  topics,
}: {
  title: string;
  focus: string;
  topics: string[];
}) {
  const { t } = useTranslation();
  return (
    <section className="rounded-xl border border-info-foreground/15 bg-info/50 p-5 sm:p-6">
      <p className="text-xs font-medium uppercase tracking-wide text-info-foreground">
        {t("passportVig.lesson.formats.visual")}
      </p>
      <h4 className="mt-2 text-xl font-medium">{title}</h4>
      <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{focus}</p>
      <ol className="mt-5">
        {steps.map(({ key, Icon }, index) => (
          <li key={key}>
            {index > 0 ? (
              <ArrowDown aria-hidden="true" className="my-2 ml-5 size-5 text-info-foreground/50" />
            ) : null}
            <div className="flex items-start gap-4 rounded-xl border border-border/50 bg-background p-4 shadow-xs">
              <div className="flex shrink-0 flex-col items-center gap-1.5 text-info-foreground">
                <span className="text-xs font-medium">{String(index + 1).padStart(2, "0")}</span>
                <Icon aria-hidden="true" className="size-8" strokeWidth={1.5} />
              </div>
              <div className="min-w-0">
                <h5 className="font-medium">{t(`passportVig.lesson.steps.${key}.title`)}</h5>
                <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                  {t(`passportVig.lesson.steps.${key}.body`)}
                </p>
                {topics[index] ? (
                  <p className="mt-3 border-l-2 border-info-foreground/25 pl-3 text-sm font-medium">
                    {topics[index]}
                  </p>
                ) : null}
              </div>
            </div>
          </li>
        ))}
      </ol>
      <p className="mt-4 text-xs text-muted-foreground">{t("passportVig.lesson.takeaway")}</p>
    </section>
  );
}
